'use strict';

require('../../company/publications/CompanyPublicationFileService.js');
require("../../company/publications/CompanyPublicationActivity.js");
require("../../company/publications/CompanyPublicationActivityDirective.js");

var LIMIT = 21;

function CompanyGuestCustomerAdaptionDetailCtrl(
  $scope,
  publication,
  files,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyPublicationService,
  CompanyPublicationFileService,
  $sce,
  config,
  activityService
) {
  $scope.publication        = publication;
  $scope.files              = files.slice(0, LIMIT);
  $scope.translations       = translations;
  $scope.activityService    = activityService;
  $scope.currentPage        = $stateParams.page|0;
  $scope.hasMore            = files.length > LIMIT;
  $scope.searchFileStr      = $stateParams.searchFile || "";

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
        'content': '',
        'template': 'partials/company-guest/customer-adaption/detail/latest.html',
        'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;
}

CompanyGuestCustomerAdaptionDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.query({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit: LIMIT + 1,
      offset: ($stateParams.page|0) * LIMIT,
      q: $stateParams.searchFile || ""
    }).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestCustomerAdaptionDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestCustomerAdaptionDetailCtrl', [
  '$scope',
  'publication',
  'files',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyPublicationService',
  'CompanyPublicationFileService',
  '$sce',
  'config',
  'activityService',
  CompanyGuestCustomerAdaptionDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/customer-adaption/CompanyGuestCustomerAdaptionDetailCtrl.js
// module id = 288
// module chunks = 0